import {
    personalChildren
} from './personalChildren'
export const children = [{
        path: '/home',
        name: 'home',
        component: () => import('@/views/page/home'),
        meta: {
            active: 'home',
            name: '首页',
            tabShow: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login'),
        meta: {
            active: 'home',
            name: '登录',
            tabShow: false
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register'),
        meta: {
            active: 'home',
            name: '注册',
            tabShow: false
        }
    },
    {
        path: '/forgetpwd',
        name: 'forgetpwd',
        component: () => import('@/views/forgetpwd'),
        meta: {
            active: 'home',
            name: '忘记密码',
            tabShow: false
        }
    },
    {
        path: '/institutionStudent',
        name: 'institutionStudent',
        component: () => import('@/views/institutionStudent'),
        meta: {
            active: 'home',
            name: '完善信息',
            tabShow: false
        }
    },
    {
        path: '/courseList',
        name: 'courseList',
        component: () => import('@/views/page/courseList'),
        meta: {
            active: 'courseList',
            name: '课程',
            tabShow: true
        }
    },
    {
        path: '/acourseDetails',
        name: 'acourseDetails',
        component: () => import('@/views/page/acourseDetails'),
        meta: {
            active: 'courseList',
            name: '课程详情',
            tabShow: false
        }
    },
    {
        path: '/courseDetails',
        name: 'courseDetails',
        component: () => import('@/views/page/courseDetails'),
        meta: {
            active: 'courseList',
            name: '课程详情',
            tabShow: false
        }
    },
    {
        path: '/vcourseDetails',
        name: 'vcourseDetails',
        component: () => import('@/views/page/vcourseDetails'),
        meta: {
            active: 'courseList',
            name: '课程详情',
            tabShow: false
        }
    },
    {
        path: '/expert',
        name: 'expert',
        component: () => import('@/views/page/expert'),
        meta: {
            active: 'expert',
            name: '专家',
            tabShow: true
        }
    },
    {
        path: '/expertDetail',
        name: 'expertDetail',
        component: () => import('@/views/page/expertDetail'),
        meta: {
            active: 'expert',
            name: '专家详情',
            tabShow: false
        }
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('@/views/page/policy'),
        meta: {
            active: 'policy',
            name: '发现',
            tabShow: true
        }
    },
    {
        path: '/policyMore',
        name: 'policyMore',
        component: () => import('@/views/page/policyMore'),
        meta: {
            active: 'policy',
            name: '政策',
            tabShow: false
        }
    },
    {
        path: '/policyDetail',
        name: 'policyDetail',
        component: () => import('@/views/page/policyDetail'),
        meta: {
            active: 'policy',
            name: '政策详情',
            tabShow: false
        }
    },
    {
        path: '/jobSeek',
        name: 'jobSeek',
        component: () => import('@/views/page/jobSeek'),
        meta: {
            active: 'jobSeek',
            name: '求职通道',
            tabShow: true
        }
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/page/search'),
        meta: {
            active: 'search',
            name: '搜索',
            tabShow: false
        }
    },
    {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('@/views/page/personalCenter'),
        meta: {
            active: 'personalCenter',
            name: '个人中心',
            tabShow: false
        },
        children: personalChildren
    },
]